import { REDUCER_NAME } from "./consts";
import { reducer } from "./reducer";
import { actions } from "./actions";

export const globalSettings = {
  reducerName: REDUCER_NAME,
  actions,
  reducer,
};
